var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarShine = function SvgStarShine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 2V1m0 22v-2.766M1 12h2.719m16.562 0H23M6.063 19.226l-2.017 2.016M17.938 5.04l2.016-2.017M6.063 5.04 4.046 3.023M17.938 18.96l2.016 2.017M12.417 4.696l1.915 3.83 3.684.368a.466.466 0 0 1 .284.794l-3.036 3.034 1.126 4.124a.467.467 0 0 1-.659.54L12 15.522l-3.731 1.867a.467.467 0 0 1-.658-.54l1.125-4.125L5.7 9.686a.466.466 0 0 1 .284-.794l3.684-.368 1.915-3.83a.466.466 0 0 1 .834.002"
  })));
};
export default SvgStarShine;